module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/5-a91fc49a64d1cbde807a274bc88cda17.jpg";